import { ReflexivePronounsFormal } from "../../../SubjectData/BasicWords/Pronouns.js";
import "../../Deck.css";
import FlashcardInterface from "../../Flashcard_Interface.js";
import HeaderNav from "../../../Components/Header/Header_Nav/Header_Nav.js";



export default function ReflexivePronounsFormalDeck() {


 return (
    <>
      <HeaderNav GoBack_to="/PronounsNav" />
      <FlashcardInterface deckData={ReflexivePronounsFormal} title="Reflexive Pronouns (Formal)" />
    </>
)}